import { Header4, InlineText2 } from '@cian/ui-kit';

import { clsx } from 'clsx';
import { FC } from 'react';

import { ISpecificationItemProps } from './types';

import * as styles from './styles.css';

export const SpecificationItem: FC<ISpecificationItemProps> = props => {
  const { text, title, icon: Icon, className } = props;

  if (!text) {
    return null;
  }

  return (
    <div className={clsx(styles['root'], className)}>
      <Icon />
      <div className={styles['description']}>
        <InlineText2 color="gray60_100">{title}</InlineText2>
        <Header4>{text}</Header4>
      </div>
    </div>
  );
};

SpecificationItem.displayName = 'SpecificationItem';
